import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import placeholderLogo from 'assets/images/logo/logo.png';
import logo from 'assets/images/logo/logoXpoPRO.png';
import 'react-toastify/dist/ReactToastify.css';

export default class WelcomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: true,
    };
  }

  render() {
    const { buttonDisabled } = this.state;

    const enableButton = () => {
      this.setState({ buttonDisabled: false });
    };

    return (
      <div className="welcomeView">

        <div className="gradient" />
        <div className="bg" />

        <div className="welcomeHolder">

          <div className="title">
            <img src={placeholderLogo} alt="logo" />
            <span>Welcome to the show!</span>
          </div>
          <div className="subtitle">
            <span>Please Welcome your Keynote Speaker</span>
            <span>Dean Jacobberger, Member Director BRAND USA</span>
          </div>

          <div className="video" id="keynotesVid">
            <video
              src="https://s3.amazonaws.com/developertool/614/welcome3.mp4"
              autoPlay
              preload="auto"
              poster="https://front.travpromobile.com/614/welcome2.jpg"
              height="100%"
              width="100%"
              controls
              onEnded={() => enableButton()}
            >
              <track kind="captions" />
            </video>
          </div>

          <Link to="/main">
            <button className="continue" id="keynotesButton" disabled={buttonDisabled}>
              Continue to Show Floor (+100xp) &gt;
            </button>
          </Link>
        </div>
        <div className="powered">
          <text>Powered by</text>
          <img src={`/${logo}`} className="logo__bottom" alt="logo" />
        </div>
      </div>
    );
  }
}
